const semanticClassNames = {
  root: 'hamburger-close-button',
  buttonLabel: 'hamburger-close-button__label',
  buttonIcon: 'hamburger-close-button__icon',
} as const;

export default semanticClassNames;
